/**
 * https://fonts.google.com/icons
 * 
 * <ai-media-planner-icon size="extra-large" state="primary" name="account_circle"></ai-media-planner-icon>
 */

import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { UIState } from '../uistate.enum';
import { DefaultIconSize } from './icon-size.enum';
import { IconSizePipe } from './icon-size.pipe';
import { IconStatePipe } from './icon-state.pipe';

@Component({
  selector: 'ai-media-planner-icon',
  templateUrl: './icon.component.html',
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ],
  imports: [MatIconModule, IconSizePipe, IconStatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconComponent {

  size = input(DefaultIconSize);

  state = input(UIState.Default);

  type = input('outlined');

  name = input('');

  isSVG = input(false);

  svgName = input('');
}
